<template>
  <v-data-table
    :headers="headers"
    :items="assetReservationObjects"
    :page.sync="pagination.page"
    :loading="loading"
    loading-text=""
    :items-per-page.sync="paginationReservationObjects.rowsPerPage"
    :items-per-page-text="rowsPerPageText"
    :items-per-page-items="rowsPerPageItems"
    :header-props="{ sortIcon }"
    :footer-props="{ prevIcon, nextIcon, 'items-per-page-options':rowsPerPageItems }"
    class="elevation-2"
    :class="{ 'no-show-permission': !userHasPermissionTo('show') }"
    @pagination="setRowsOnLocalStorage(dataTableReservationListId,paginationReservationObjects.rowsPerPage)"
  >
    <template v-slot:item="props">
      <tr
        @click="viewItem(props.item)"
        :class="{
          'cursor-pointer':
            userHasPermissionTo('show') && !props.item.aro_is_network_element
        }"
      >
        <td>
          <reservation-state-icon :state="props.item.state" />
        </td>

        <td>
          {{ props.item.aro_is_network_element ? $t("No") : $t("Yes") }}
        </td>

        <td>{{ getObjectType(props.item) }}</td>

        <td>{{ props.item.object_id }}</td>

        <td>{{ props.item.object_label }}</td>

        <td>
          {{ props.item.aro_installation_start_date }}
        </td>

        <td>{{ props.item.aro_installation_end_date }}</td>
      </tr>
    </template>

    <template v-slot:pageText="props">
      {{ props.pageStart }} - {{ props.pageStop }} {{ $t("tables.Of") }}
      {{ props.itemsLength }}
    </template>
  </v-data-table>
</template>

<script>
import { managementDatatableMixin } from "@/mixins/management/managementDatatableMixin";
import ReservationStateIcon from "@/components/AssetReservationManagement/Data/StateIcon";

export default {
  name: "AssetReservationManagementReservationObjectsTable",

  components: { ReservationStateIcon },

  mixins: [managementDatatableMixin],

  props: {
    /**
     * Receives the objects that are associated with the selected reservation asset
     */
    assetReservationObjects: {
      type: Array
    },
    loading: Boolean,
  },

  data() {
    return {
      /**
       * Stores all information regarding the pagination of the table (page number| number of items| sort)
       */
      pagination: {
        sortBy: "object_id"
      },
      dataTableReservationListId: "dataTableReservationListId" ,
      paginationReservationObjects: {
        rowsPerPage: this.getRowsFromLocalStorage("dataTableReservationListId")
      },
      /**
       * Permission name referring to the functionality of asset reservation objects
       */
      permissionName: "asset_reservation_object"
    };
  },

  computed: {
    /**
     * Determines table headers for asset reservation objects
     * {String} value - Column key
     * {String} text - Column title
     * {String} align - Column alignment
     */
    headers() {
      return [
        {
          text: this.$i18n.t("State"),
          align: "left",
          value: "state.main_description",
          width: "10%"
        },
        {
          text: this.$i18n.tc("Asset", 1),
          value: "aro_is_network_element",
          width: "10%"
        },
        {
          text: this.$i18n.tc("Type", 1),
          value: "aro_object_layer",
          width: "10%"
        },
        {
          text: "ID",
          value: "object_id",
          width: "10%"
        },
        {
          text: this.$i18n.tc("Label", 1),
          value: "object_label",
          width: "20%"
        },
        {
          text: this.$i18n.t("InstallationStartDate"),
          value: "aro_installation_start_date",
          width: "20%"
        },
        {
          text: this.$i18n.t("InstallationEndDate"),
          value: "aro_installation_end_date",
          width: "20%"
        }
      ];
    }
  },

  methods: {
    /**
     * Returns the object's layer
     * @param assetReservationObject
     * @returns {string}
     */
    getObjectType(assetReservationObject) {
      let layerTranslationName = this.$store.getters.getLayerTranslationKey(
        assetReservationObject.aro_object_layer
      );
      return this.$i18n.tc(layerTranslationName, 1);
    },

    /**
     * Push to the page to see the selected client role
     * @param {Object} item - Selected client role
     */
    viewItem(assetReservationObject) {
      if (!assetReservationObject.aro_is_network_element) {
        this.$emit("open-asset", assetReservationObject);
      }
    },

    /**
     * Determines whether the user has the permission for the action it receives
     * @param action
     * @returns {Boolean}
     */
    userHasPermissionTo(action) {
      return this.userHasFibercloudPermission(this.permissionName, action);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AssetReservationManagement/Data/ReservationObjectsTable.vue